import { go } from "../route/Route";


function handleClick(e: any) {
	const url = e.target.href;
	go(url);
	e.preventDefault();
}


export function Link(props: {
	href: string,
	title: string,
}) {
	return (
		<a href={props.href} onClick={handleClick}>{props.title}</a>
	);
}